//DONE
export default function Armor() {
    return (
        <>
            <p>Every armor has a name, base damage thresholds, and a base Armor Score. Some armor also has a feature</p>
            <ul>
                <li>An armor's <strong>base armor score</strong> indicates how many Armor Slots
                    it provides its wearer before additional bonuses are
                    added to calculate their total Armor Score. A PC's Armor
                    Score can't exceed 12.</li>
                <li>An armor's <strong>base thresholds</strong> determine its wearer's Major
                    and Severe damage thresholds before adding bonuses to
                    calculate their final damage thresholds. When recording
                    your character's damage thresholds in the “Damage &
                    Health” section of your character sheet, you always add
                    your character's level to those values.</li>
                <li>An armor's <strong>feature</strong> is a special rule that stays in effect
                    while the armor is equipped.</li>
            </ul>
            <p>While <strong>unarmored</strong>, your character's base Armor Score is 0,
                their Major threshold is equal to their level, and their Severe
                threshold is equal to twice their level.</p>
            <h3>REDUCING INCOMING DAMAGE</h3>
            <p>When you take damage, you can mark one Armor Slot to
                reduce the severity of the damage by one threshold (Severe
                to Major, Major to Minor, Minor to Nothing). If your character
                has an Armor Score of 0, you can't mark Armor Slots. If an
                effect temporarily increases your Armor Score, it increases
                your available Armor Slots by the same amount; when the
                effect ends, so does the availability of these Armor Slot.</p>

        </>
    );
}